import { Reducer } from 'redux';
import { HomeFinancialsState, HomeFinancialsTypes } from './types';

const INITIAL_STATE: HomeFinancialsState = {
  data: [],
  loading: false,
};

const reducer: Reducer<HomeFinancialsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HomeFinancialsTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case HomeFinancialsTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        ...action.payload
      };
    case HomeFinancialsTypes.LOAD_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default reducer;
